<script setup>
  defineProps({
    breadcrumbs: Array,
    sections: Array,
    module: Object,
  });
</script>
<template>
  <main class="container">
    <SfBreadcrumbs :breadcrumbs="breadcrumbs" />
    <h1 class="terms-condition-heading">{{ module.title }}</h1>
    <p class="terms-condition-description">
      {{ module.description_short }}
    </p>
    <SectionRenderer :sections="sections" />
  </main>
</template>
<style scoped lang="scss">
  .terms-condition-description {
    margin: 1rem 0 2rem;
  }

  @media(max-width: 992px) {
    .terms-condition-heading,
    .terms-condition-description {
      padding: 0 0.625rem;
    }
  }
</style>